module.exports = __webpack_public_path__ + "images/c5bc412b.row-text-bg5.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/row-text-bg5.png
// module id = 565
// module chunks = 0